import React, { useContext, useEffect, useRef, useState } from "react";
import { Context } from "../../../context/Context";
import "./Motor.css";
import MotorSlider from "./Sliders/MotorSlider";
import SimpleBar from "simplebar-react";
import "simplebar-react/dist/simplebar.min.css";

const Motor = ({
  equipment_id,
  closeSelectEquipmentRef,
  closeSelectOutputEquipmentRef,
  commands,
  setCommands,
}) => {
  const {
    addScenarioCommandDetail,
    scenarioCommandDetail,
    scenarioCommands,
    setScenarioCommands,
    equipmentButtons,
  } = useContext(Context);
  const [buttons, setButtons] = useState([]);
  const [selectedButton, setSelectedButton] = useState({
    state: 0,
    sliderValue: 0,
  });

  useEffect(() => {
    // setIsLoading(true);
    // AllEquipmentButton({
    //   equipment_id: equipment_id,
    // }).then(({ data }) => {
    //   setButtons(data.equipment_buttons);
    //   setIsLoading(false);
    // });

    setButtons(
      equipmentButtons.filter((eq_btn) => eq_btn.equipment_id == equipment_id)
    );
  }, [equipmentButtons, equipment_id]);

  const handleChangeMotorStatus = () => {
    setSelectedButton((prev) => ({
      ...prev,
      state: prev.state ? 0 : 1,
    }));
  };

  const handleChangeSliderValue = (val) => {
    setSelectedButton((prev) => ({
      ...prev,
      sliderValue: val < 0 ? val + 256 : val,
    }));
  };

  const handleSubmit = () => {
    const button = buttons[0];
    let data1 = 9;
    let data2 = selectedButton.state;
    let data3 = 0;
    let data4 = selectedButton.sliderValue;

    if (scenarioCommandDetail.id) {
      // setIsLoading(true);
      setCommands((prevCommands) =>
        prevCommands.map((command) =>
          command.id == scenarioCommandDetail.id
            ? {
                ...command,
                device_id: button.device_id,
                time: scenarioCommandDetail.time,
                data1: data1,
                data2: data2,
                data3: data3,
                data4: data4,
                data5: null,
                data6: null,
                data7: null,
                data8: null,
                data9: null,
                data10: null,
                data11: null,
                command_name: "POW",
                icon: button.icon,
              }
            : command
        )
      );
      closeSelectEquipmentRef.current.click();
      closeSelectOutputEquipmentRef.current.click();
      // UpdateScenarioCommand({
      //   scenario_command_id: scenarioCommandDetail.id,
      //   device_id: button.device_id,
      //   time: scenarioCommandDetail.time,
      //   data1: data1,
      //   data2: data2,
      //   data3: data3,
      //   data4: data4,
      //   command_name: button.name,
      //   icon: button.icon,
      // }).then(({ data: sData }) => {
      //   SuccessToast("دستور با موفقیت جایگزین شد");
      //   const newScenarioCommands = scenarioCommands.map((scn) => {
      //     if (scn.id === scenarioCommandDetail.id) {
      //       return {
      //         ...scn,
      //         device_id: button.device_id,
      //         time: scenarioCommandDetail.time,
      //         data1: data1,
      //         data2: data2,
      //         data3: data3,
      //         data4: data4,
      //         command_name: button.name,
      //         icon: button.icon,
      //       };
      //     }
      //     return scn;
      //   });
      //   setScenarioCommands(newScenarioCommands);
      //   setSelectedButton({
      //     state: 0,
      //     sliderValue: 0,
      //   });
      //   closeSelectEquipmentRef.current.click();
      //   closeSelectOutputEquipmentRef.current.click();
      //   setIsLoading(false);
      // });
    } else {
      setCommands((prev) => [
        ...prev,
        {
          id: new Date().getTime(),
          scenario_id: addScenarioCommandDetail.scenario_id,
          data1: data1,
          data2: data2,
          data3: data3,
          data4: data4,
          data5: null,
          data6: null,
          data7: null,
          data8: null,
          data9: null,
          data10: null,
          data11: null,
          command_name: "POW",
          icon: button.icon,
          device_id: button.device_id,
          time: 500,
        },
      ]);
      closeSelectEquipmentRef.current.click();
      closeSelectOutputEquipmentRef.current.click();
      // setIsLoading(true);
      // CreateScenarioCommand({
      //   scenario_id: addScenarioCommandDetail.scenario_id,
      //   data1: data1,
      //   data2: data2,
      //   data3: data3,
      //   data4: data4,
      //   command_name: button.name,
      //   icon: button.icon,
      //   device_id: button.device_id,
      //   time: 500,
      // }).then(({ data }) => {
      //   SuccessToast("دستور با موفقیت اضافه گردید");
      //   setScenarioCommands([...scenarioCommands, data.scenario_command]);
      //   setSelectedButton({
      //     state: 0,
      //     sliderValue: 0,
      //   });
      //   closeSelectEquipmentRef.current.click();
      //   closeSelectOutputEquipmentRef.current.click();
      //   setIsLoading(false);
      // });
    }
    setSelectedButton({
      state: 0,
      sliderValue: 0,
    });
  };

  return (
    <div className="card h-100" style={{backgroundColor: 'transparent', boxShadow: 'unset'}}>
      <div
        className="card-header d-flex align-items-center justify-content-between border-bottom p-0 pt-2"
        style={{ zIndex: 1, top: "0" }}
      >
        <h5>{buttons?.[0]?.equipment?.name ?? ""}</h5>
        <button
          type="button"
          className="btn btn-icon btn-success-app"
          onClick={handleSubmit}
        >
          <span className="tf-icons bx bx-check"></span>
        </button>
      </div>
      <div className="card-body scrollbar">
        {/* <SimpleBar style={{ maxHeight: "100%", padding: "0.3rem" }}> */}
          <div className="row motor-box rounded-3">
            <div className="col-12">
              <div className="d-flex justify-content-around">
                <div>مشعل</div>
                <div>
                  <div className="form-check form-switch mb-2">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      id="flexSwitchCheckChecked"
                      checked={selectedButton.state ? "checked" : ""}
                      onChange={handleChangeMotorStatus}
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className="col-12 text-center slider-power mt-4">
              <MotorSlider value={0} setValue={handleChangeSliderValue} />
            </div>
            {/* <div className="col-12 mt-4">
              <div className="d-flex justify-content-between flex-wrap">
                <div className="motor-status">
                  <p className="text-center">دمای بیرون</p>
                  <p className="text-center" dir="ltr">
                    -
                  </p>
                  <img src="/assets/img/app-icons/Jf.png" alt="" />
                  <p className="text-center">پمپ 3</p>
                  <p className="text-center" dir="ltr">
                    -
                  </p>
                  <p className="text-center" dir="ltr">
                    -
                  </p>
                </div>
                <div className="motor-status">
                  <p className="text-center">دمای موتورخانه</p>
                  <p className="text-center" dir="ltr">
                    -
                  </p>
                  <img src="/assets/img/app-icons/Jf.png" alt="" />
                  <p className="text-center">پمپ 2</p>
                  <p className="text-center" dir="ltr">
                    -
                  </p>
                  <p className="text-center" dir="ltr">
                    -
                  </p>
                </div>
                <div className="motor-status">
                  <p className="text-center">دمای تنظیم</p>
                  <p className="text-center" dir="ltr">
                    -
                  </p>
                  <img src="/assets/img/app-icons/Jf.png" alt="" />
                  <p className="text-center">پمپ 1</p>
                  <p className="text-center" dir="ltr">
                    -
                  </p>
                  <p className="text-center" dir="ltr">
                    -
                  </p>
                </div>
              </div>
            </div> */}
          </div>
        {/* </SimpleBar> */}
      </div>
    </div>
  );
};

export default React.memo(Motor);
